import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { IServiceRequest, IServiceRequestStage } from 'src/app/common/models/service-request.model';
import { ProvidehttpService } from 'src/app/providehttp.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestHistoryService {
  serviceRequest: IServiceRequest[];
  serviceRequestStages: IServiceRequestStage[];
  private _trackerDetails: any;
  getTrackerDetails() {
    return this._trackerDetails;
  }
  setTrackerDetails(value) {
    this._trackerDetails = value;
  }
  resetTrackerDetails() {
    this._trackerDetails = undefined
  }
  constructor(private _httpProvider:HttpProviderService,
    public http: ProvidehttpService,) { }

    fetchServiceRequest(filter = null):Observable<IServiceRequest[]>{
      if(filter) filter = JSON.stringify(filter);
      const httpRequest : HttpRequestPayload = {
        resource : `/retail/servicerequest`,
        method : "GET",
        queryParams:[
          {
            key: "criteriaDetails",
            value: filter
          },
        ]
      }
      
      return this._httpProvider.invokeApi(httpRequest).pipe(
        map((res : IHttpSuccessPayload<any>) => {
          this.serviceRequest = res.body['serviceRequestDetails'];
          return this.serviceRequest;
        }),
        catchError((err : IHttpErrorPayload) => { 
          return throwError(err)
      }));
    }

    fetchFilteredServiceRequest():Observable<IServiceRequest[]>{
      const httpRequest : HttpRequestPayload = {
        resource : `/retail/servicerequest`,
        method : "GET"
      }
      
      return this._httpProvider.invokeApi(httpRequest).pipe(
        map((res : IHttpSuccessPayload<any>) => {
          this.serviceRequest = res.body['serviceRequestDetails'];
          return this.serviceRequest;
        }),
        catchError((err : IHttpErrorPayload) => { 
          return throwError(err)
      }));
    }

    getServiceRequestItem(requestReference): IServiceRequest {
      return this.serviceRequest.filter(item=>{
        return item.requestReference == requestReference
      })[0]
    }
    fetchServiceReqStages(requestReference):Observable<IServiceRequestStage[]>{

      const httpRequest : HttpRequestPayload = {
        resource : `/retail/servicerequest/stages/${requestReference}`,
        method : "GET"
      }
      
      return this._httpProvider.invokeApi(httpRequest).pipe(
        map((res : IHttpSuccessPayload<any>) => {
          this.serviceRequestStages = res.body['serviceRequestStages'];
          return this.serviceRequestStages;
        }),
        catchError((err : IHttpErrorPayload) => { 
          return throwError(err)
      }));
    }

}
